import type { FC } from 'react';
import type { CongressBase } from '@domain/index';
import {
  EuiFlexGroup,
  EuiFlexItem,
  EuiTitle,
  EuiBadge,
  EuiSpacer,
  EuiCallOut,
} from '@elastic/eui';
import EuiLinkButton from '@components/buttons/eui-link-button';
import { formatDateString } from '@lib/utils';
import { MdSwapHoriz } from 'react-icons/md';

interface HeaderProps {
  congress: CongressBase;
}

const Header: FC<HeaderProps> = ({ congress }) => {
  return (
    <>
      <EuiFlexGroup direction="row" alignItems="baseline" gutterSize="m">
        <EuiFlexItem grow={true}>
          <EuiFlexGroup
            direction="row"
            responsive={false}
            alignItems="baseline"
            gutterSize="m">
            <EuiFlexItem grow={false}>
              <EuiTitle>
                <h2>{congress.name}</h2>
              </EuiTitle>
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
              <EuiTitle size="xs">
                <p>{formatDateString(congress.date)}</p>
              </EuiTitle>
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
              {congress.active ? (
                <EuiBadge color="success">Active</EuiBadge>
              ) : (
                <EuiBadge color="danger">Not active</EuiBadge>
              )}
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <EuiLinkButton iconType={MdSwapHoriz} href="/choose-congress">
            Change congress
          </EuiLinkButton>
        </EuiFlexItem>
      </EuiFlexGroup>
      {!congress.active && (
        <>
          <EuiSpacer size="m" />
          <EuiCallOut
            size="s"
            color="warning"
            iconType="warning"
            title="This congress is not active."
          />
        </>
      )}
    </>
  );
};

export default Header;
